import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthorsComponent} from './authors.component';

const routes: Routes = [
    {
        path: 'authors',
        component: AuthorsComponent,
        data: {animation: 'authors'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class AuthorsRoutingModule {
}
